import { html, customElement } from '@adobe/edex/ui/edex-lit';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-download';
import styles from '@adobe/edex/ui/components/resource/download-local/download-local.lit.scss';
import * as resourceAPI from '@adobe/edex/ui/api/resource';
import { EdexDomID, EdexTagName, AdobeAnalyticsEvent } from '@adobe/edex/ui/shared/constants';
import { BaseAuthElement } from '@adobe/edex/ui/components/base.element';
import { FileSchema } from '@adobe/edex/ui/shared/types';
import { delay, trackTargetEvent } from '@adobe/edex/ui/shared/utils';
import { I18nKey } from '@adobe/edex/ui/shared/constants/i18n';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
import { AnalyticsEvent } from '@adobe/edex/ui/constants';
import { Analytics } from '@adobe/edex/ui/shared/config/analytics';
import { DownloadPayLoad } from '@adobe/edex/ui/types/payload';

@customElement(EdexTagName.downloadLocal)
export class DownloadLocal extends BaseAuthElement {
  get useLightDom() {
    return true;
  }
  static styles = styles;
  static get properties() {
    return {
      ...super.properties,
      file: { type: Object },
      resourceID: { type: String },
      loading: { type: Boolean },
    };
  }
  file: FileSchema;
  resourceID: string;
  loading = false;

  get downloadLink() {
    if (!this.file) {
      return '';
    }
    const {
      file: { storagePath, updatedAt },
    } = this;
    return `${storagePath}?q=${new Date(updatedAt).getTime()}`;
  }

  async handleDownloadToDeviceClick() {
    this.authGuard();
    if (this.loading) {
      return;
    }

    // Need to call exportZIP everytime, since the title may have changed,
    // since the filename is changed based on title, see CCEDU-2944.
    //if (true || !this.file || this.file.label.startsWith('ResourceBundle')) {
    this.loading = true;
    const response = await resourceAPI.exportZIP(this.resourceID);

    // wait for download link to re-render
    this.file = response.data;
    await delay();
    //}

    // trigger browser download
    this.querySelector<HTMLElement>(`#${EdexDomID.downloadLink}`).click();

    this.track({
      event: AnalyticsEvent.resourceClickDownloadToDevice,
      payload: { id: this.resourceID, fileID: this.file?.id },
    });

    Analytics.getInstance().emitEvent(AdobeAnalyticsEvent.resourceDownloadLocal, 'Resource download to device');
    trackTargetEvent('edex-resource-download-to-local-click');
    const link = '', // empty link is sent, so that "Got it" button closes the dialog after download.
      folderName = this.file.label;
    // Adding delay for above click event to trigger download and prevent closing of success dialog (CCEDU-9207)
    await delay(200);
    this.emitEvent<DownloadPayLoad>('success', { link, folderName });
  }

  render() {
    const { loading, downloadLink } = this;
    return html`
      <a id=${EdexDomID.downloadLink} href="${downloadLink}" style="display: none;"></a>
      <sp-button @click="${this.handleDownloadToDeviceClick}">
        ${loading
          ? html`
              <sp-progress-circle size="small" slot="icon" indeterminate></sp-progress-circle>
            `
          : html`
              <sp-icon slot="icon" size="s">
                <sp-icon-download></sp-icon-download>
              </sp-icon>
            `}
        ${$t(I18nKey.downloadToDevice)}
      </sp-button>
    `;
  }
}
